module.exports = __webpack_public_path__ + "static/media/26UNRWA25.973cd654.jpg";